import { memo, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useRouter } from 'next/router';
import cn from 'classnames';
import { NavbarUtilityHeader } from '@zmedia/bm-common/layout/header/navbar';
import { ObjectUtils } from 'src/utils';
import useSticky from 'src/hooks/useSticky';
import { loadAppConfig } from 'src/redux/actions/app';
import { isIABMSelector, isMiniappSelector } from 'src/selectors/app';
import { Container, Element, IconButton } from 'src/components';
import RouterLink from 'src/components/links';
import Level from 'src/components/grid/level';
import UserProfile from './user';
import NavbarHeader from './navbar';
import { twMerge } from 'tailwind-merge';
interface IProps {
    page: string;
    showMenu?: boolean;
    config?: any;
    children?: React.ReactNode;
}

function Header({ page, showMenu, config, children }: IProps) {
    const [hasAds, setHasAds] = useState<boolean>(false);
    const isIframe = useSelector(isMiniappSelector);
    const [isSticky] = useSticky({ page, isIframe });
    const headerRef = useRef<HTMLDivElement>(null);
    const isIABM = useSelector(isIABMSelector);
    const dispatch = useDispatch();

    const router = useRouter();

    useEffect(() => {
        if (ObjectUtils.isEmpty(config)) {
            dispatch(loadAppConfig());
        }
    }, []);

    useEffect(() => {
        setTimeout(() => {
            if (headerRef.current) {
                const rect = headerRef.current.getBoundingClientRect();
                setHasAds(rect.top > 0);
            }
        }, 400);
    }, [headerRef.current]);

    useEffect(() => {
        window.parent.postMessage(
            { type: 'FROM_BAOMOI', data: { loading: true } },
            'https://h5.zdn.vn',
        );
    }, []);

    return (
        <Element
            className={twMerge(
                'header-wrapper',
                cn({
                    ['mb-[40px]']: page?.indexOf('widget') == -1 && isSticky,
                    ['pb-[40px] mb-0']:
                        page?.indexOf('widget') == -1 && isIframe && !hasAds,
                }),
            )}
            domRef={headerRef}
        >
            <Element
                renderAs="header"
                className={cn('bm-header', 'relative', 'h-[50px]', 'z-[100]', {
                    hidden: isIframe,
                })}
            >
                <Container className="h-full">
                    <Level className="h-full">
                        <Level.Side align="left">
                            <Element
                                renderAs={router.asPath === '/' ? 'h1' : 'div'}
                                className="flex"
                            >
                                {isIABM ? (
                                    <Element
                                        className={cn(
                                            'w-[100px] h-[44px]',
                                            'block',
                                            'bg-[length:100px_44px] bg-[0_0]',
                                            'bg-no-repeat',
                                            'bg-[url(https://baomoi-static.bmcdn.me/wap/styles/img/bm-logo-v3.png)]',
                                        )}
                                    />
                                ) : (
                                    <RouterLink
                                        to={'/'}
                                        alt="Trang chủ"
                                        title="Trang chủ"
                                        className={cn(
                                            'w-[100px] h-[44px]',
                                            'block',
                                            'bg-[length:100px_44px] bg-[0_0]',
                                            'bg-no-repeat',
                                            'bg-[url(https://baomoi-static.bmcdn.me/wap/styles/img/bm-logo-v3.png)]',
                                        )}
                                    />
                                )}
                                {/* <Element
                                    className={cn(
                                        'flex items-center justify-center',
                                        'w-[40px] h-[20px]',
                                        'text-white uppercase font-[800] leading-[1]',
                                        'bg-[#F05B2F]',
                                        'rounded-[4px]',
                                        'ml-[4px]',
                                    )}
                                >
                                    Beta
                                </Element> */}
                            </Element>
                        </Level.Side>
                        <Level.Side align="right">
                            <UserProfile />
                            <RouterLink
                                to="/tim-kiem.epi"
                                alt="search"
                                className={cn(
                                    'mr-[-8px]',
                                    'flex items-center justify-center',
                                    'h-[36px] w-[36px]',
                                    'bg-[#f2f2f2]',
                                    'rounded-full',
                                )}
                            >
                                <IconButton
                                    title="Tìm kiếm"
                                    className={cn(
                                        'flex items-center justify-center',
                                        'rounded-[3px]',
                                        'p-[6px]',
                                    )}
                                    classNameIcon="text-[20px] text-[#666]"
                                    icon="new-search-regular"
                                />
                            </RouterLink>
                        </Level.Side>
                    </Level>
                </Container>
            </Element>
            {page?.indexOf('widget') > -1 && (
                <NavbarUtilityHeader
                    page={page}
                    classNames="mt-0"
                    containerClass={cn(
                        'mx-auto p-[16px]',
                        'w-full',
                        'xs:max-md:px-[10%]',
                        'md:max-w-[758px] ',
                        'lg:max-w-[1000px]',
                        'xl:max-w-[1242px]',
                        '2xl:max-w-[1484px]',
                        '3xl:max-w-[1726px]',
                    )}
                />
            )}
            {showMenu && (
                <NavbarHeader
                    isSticky={isSticky || (isIframe && !hasAds)}
                    config={config}
                />
            )}
            {children}
        </Element>
    );
}

export default memo(Header);
